/**
 * Enum for the status of the nft drops
 */
export enum Status {
    live = 'live',
    upcoming = 'upcoming',
    past = 'ended'
}

/**
 * Interface for the color of the badge
 * @property backgroundColor - background color of the badge
 * @property textColor - text color of the badge
 */
export interface BadgeColors {
    backgroundColor: string;
    textColor: string;
    label: string;
}

const statusColorMap: Record<Status, BadgeColors> = {
    [Status.live]: {
        backgroundColor: 'var(--bg-brand-mojito-secondary)',
        textColor: 'var(--content-brand-mojito-badge)',
        label: 'Active'
    },
    // [Status.Mint]: { backgroundColor: 'var(--bg-brand-mojito-secondary)', textColor: 'var(--bg-brand-mojito-primary)' },
    // [Status.LiveNow]: { backgroundColor: 'var(--bg-brand-mojito-secondary)', textColor: 'var(--bg-brand-mojito-primary)' },
    // [Status.LastCall]: { backgroundColor: 'var(--bg-negative-secondary)', textColor: 'var(--content-negative)' },
    [Status.upcoming]: {
        backgroundColor: 'var(--bg-brand-aviation-secondary)',
        textColor: 'var(--content-brand-aviation-badge)',
        label: 'Upcoming'
    },
    [Status.past]: {
        backgroundColor: 'var(--bg-tertary)',
        textColor: 'var(--content-secondary)',
        label: 'Past'
    }
};

/**
 * Get the color of the badge based on the status of the nft drops
 * @param status - status of the nft drop
 * @returns
 */
export function getBadgeColorsByStatus(status: Status): BadgeColors {
    return statusColorMap[status] || {
        backgroundColor: 'var(--bg-default)',
        textColor: 'var(--text-default)'
    };
}

export default function useStatusColorMap() {
    return {
        Status,
        getBadgeColorsByStatus,
        statusColorMap
    };
}
